import { createSelector } from '@ngrx/store';

import { State } from './reducer';
import { selectPartnershipValidationStepState } from '../selectors';
import { PartnershipValidation } from '@models/swagger';

export const getData = createSelector(selectPartnershipValidationStepState, (state: State) => state.data);

export const getError = createSelector(selectPartnershipValidationStepState, (state: State) => state.error);

export const getLoading = createSelector(selectPartnershipValidationStepState, (state: State) => state.loading);

export const mapData = <T>(fn: (data: PartnershipValidation | null) => T) =>
  createSelector(selectPartnershipValidationStepState, (state: State) => fn(state.data));
